import { Mail, MessageCircle, Calendar, ArrowRight, Instagram, Linkedin, MapPin, Monitor, Combine } from "lucide-react";
import SEO from "@/components/SEO";

const CAL = "https://calendar.app.google/wMsDARnKAyyi4doX6";
const WA = "https://wa.me/393475061407?text=" + encodeURIComponent("Ciao Roberta, vorrei maggiori informazioni sui tuoi servizi.");

export default function Contatti() {
  return (
    <section className="section-pad">
      <SEO
        path="/contatti"
        title="Contatti — Sessione strategica in tutta Italia (in sede, online, ibrida)"
        description="Contatta Roberta Castagna: WhatsApp, email o sessione strategica di 30 minuti su Google Meet. Consulenza aziendale in sede in tutta Italia — Catania e Sicilia (in presenza), Roma e Firenze presidiate, resto del Paese online o ibrida. Sede legale a Gravina di Catania (CT)."
      />
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-16 text-center max-w-3xl mx-auto" data-reveal>
          <p className="eyebrow mb-4">Contatti</p>
          <h1 className="font-display text-5xl sm:text-6xl leading-tight text-[#2A3229]">Parliamone.</h1>
          <p className="mt-6 text-lg text-[#5A6058] leading-relaxed">
            Scegli il canale più diretto per iniziare. Che si tratti di una prenotazione, di una domanda veloce o semplicemente di conoscerci, sono qui per ascoltarti.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 items-stretch">
          {/* WHATSAPP */}
          <a
            data-testid="contatti-whatsapp"
            href={WA}
            target="_blank"
            rel="noreferrer"
            data-reveal
            className="group relative flex flex-col bg-white border border-[#323C36]/12 p-8 sm:p-10 transition-all hover:-translate-y-1 hover:border-[#323C36]"
          >
            <div className="w-12 h-12 rounded-full bg-[#A8674F] text-[#F6F3EF] flex items-center justify-center shrink-0 mb-6">
              <MessageCircle size={20} strokeWidth={1.7}/>
            </div>
            <p className="eyebrow mb-2">Per un contatto rapido</p>
            <h2 className="font-display text-2xl sm:text-3xl text-[#2A3229] leading-tight mb-3">Scrivimi su WhatsApp</h2>
            <p className="text-[#5A6058] leading-relaxed mb-6 text-sm flex-1">
              Una domanda al volo, una curiosità, un chiarimento sul metodo o sui percorsi. Risponderò personalmente appena possibile.
            </p>
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] font-semibold text-[#323C36] group-hover:text-[#A8674F]">
              Apri WhatsApp <ArrowRight size={14} className="transition-transform group-hover:translate-x-1"/>
            </span>
          </a>

          {/* SESSIONE STRATEGICA (CENTRO) */}
          <a
            data-testid="contatti-book"
            href={CAL}
            target="_blank"
            rel="noreferrer"
            data-reveal
            data-reveal-delay="1"
            className="group relative flex flex-col bg-white border border-[#323C36]/12 p-8 sm:p-10 transition-all hover:-translate-y-1 hover:border-[#323C36] md:-mt-4"
          >
            <div className="w-12 h-12 rounded-full bg-[#323C36] text-[#F6F3EF] flex items-center justify-center shrink-0 mb-6">
              <Calendar size={20} strokeWidth={1.7}/>
            </div>
            <p className="eyebrow mb-2">Il canale principale</p>
            <h2 className="font-display text-2xl sm:text-3xl text-[#2A3229] leading-tight mb-3">Prenota una sessione strategica</h2>
            <p className="text-[#5A6058] leading-relaxed mb-6 text-sm flex-1">
              30 minuti su Meet per capire se e come possiamo lavorare insieme. Analizziamo lo stato attuale della tua impresa e individuiamo il percorso più adatto.
            </p>
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] font-semibold text-[#323C36] group-hover:text-[#A8674F]">
              Apri il calendario <ArrowRight size={14} className="transition-transform group-hover:translate-x-1"/>
            </span>
          </a>

          {/* EMAIL */}
          <a
            data-testid="contatti-email"
            href="mailto:robertacastagna1@gmail.com"
            data-reveal
            data-reveal-delay="2"
            className="group relative flex flex-col bg-white border border-[#323C36]/12 p-8 sm:p-10 transition-all hover:-translate-y-1 hover:border-[#323C36]"
          >
            <div className="w-12 h-12 rounded-full bg-[#A8674F] text-[#F6F3EF] flex items-center justify-center shrink-0 mb-6">
              <Mail size={20} strokeWidth={1.7}/>
            </div>
            <p className="eyebrow mb-2">Preferisci scrivere?</p>
            <h2 className="font-display text-2xl sm:text-3xl text-[#2A3229] leading-tight mb-3">Inviami una email</h2>
            <p className="text-[#5A6058] leading-relaxed mb-6 text-sm flex-1">
              Racconta la tua situazione, i tuoi obiettivi, il momento in cui si trova la tua azienda. Ti risponderò entro 24 ore lavorative.
            </p>
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] font-semibold text-[#323C36] group-hover:text-[#A8674F]">
              Scrivimi <ArrowRight size={14} className="transition-transform group-hover:translate-x-1"/>
            </span>
          </a>
        </div>

        {/* MODALITÀ DI COLLABORAZIONE */}
        <div className="mt-24 pt-16 border-t border-[#323C36]/12">
          <div className="text-center max-w-3xl mx-auto mb-14">
            <p className="eyebrow mb-4">Come lavoro</p>
            <h2 className="font-display text-4xl sm:text-5xl leading-tight text-[#2A3229]">
              <span className="text-[#A8674F]">Tre modalità</span> di collaborazione.
            </h2>
            <p className="mt-6 text-lg text-[#5A6058] leading-relaxed">
              La formula si sceglie insieme, in base al progetto e al momento della tua azienda.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 items-stretch" data-testid="modalita-grid">
            {/* ONLINE (sinistra) */}
            <div
              data-testid="modalita-online"
              data-reveal
              data-reveal-delay="1"
              className="group relative flex flex-col bg-white border border-[#323C36]/12 p-8 sm:p-10 transition-all hover:-translate-y-1 hover:border-[#323C36]"
            >
              <div className="w-12 h-12 rounded-full bg-[#A8674F] text-[#F6F3EF] flex items-center justify-center shrink-0 mb-6">
                <Monitor size={20} strokeWidth={1.7}/>
              </div>
              <p className="eyebrow mb-2">Modalità 01</p>
              <h3 className="font-display text-2xl sm:text-3xl text-[#2A3229] leading-tight mb-3">Consulenza 100% online</h3>
              <p className="text-[#5A6058] leading-relaxed mb-6 text-sm flex-1">
                Sessioni strategiche e affiancamento operativo da remoto via videoconferenza. Ritmi sostenuti, agenda condivisa. Ideale per titolari con calendari fitti o sedi distribuite.
              </p>
            </div>

            {/* IN SEDE (CENTRO — verde bosco in evidenza) */}
            <div
              data-testid="modalita-in-sede"
              data-reveal
              data-reveal-delay="2"
              className="group relative flex flex-col bg-[#2A3229] text-[#F6F3EF] p-8 sm:p-10 overflow-hidden transition-all hover:-translate-y-1 md:-mt-4"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#FAC075]/10 blur-3xl rounded-full transition-all group-hover:bg-[#FAC075]/20"/>
              <div className="w-12 h-12 rounded-full bg-[#FAC075] text-[#2A3229] flex items-center justify-center shrink-0 mb-6 relative">
                <MapPin size={20} strokeWidth={1.7}/>
              </div>
              <p className="eyebrow !text-[#FAC075] mb-2 relative">Modalità 02</p>
              <h3 className="font-display text-2xl sm:text-3xl leading-tight mb-3 relative">Consulenza 100% in sede</h3>
              <p className="text-[#F6F3EF]/75 leading-relaxed mb-6 text-sm relative flex-1">
                Presenza diretta e continuativa nella tua azienda. È la formula a maggior impatto, progettata per chi desidera una riorganizzazione profonda: permette di osservare i flussi reali sul campo, rilevare le inefficienze operative in tempo reale e condurre audit e affiancamenti executive a stretto contatto con la direzione e il team.
              </p>
            </div>

            {/* IBRIDA (destra) */}
            <div
              data-testid="modalita-ibrida"
              data-reveal
              data-reveal-delay="3"
              className="group relative flex flex-col bg-white border border-[#323C36]/12 p-8 sm:p-10 transition-all hover:-translate-y-1 hover:border-[#323C36]"
            >
              <div className="w-12 h-12 rounded-full bg-[#323C36] text-[#F6F3EF] flex items-center justify-center shrink-0 mb-6">
                <Combine size={20} strokeWidth={1.7}/>
              </div>
              <p className="eyebrow mb-2">Modalità 03</p>
              <h3 className="font-display text-2xl sm:text-3xl text-[#2A3229] leading-tight mb-3">Consulenza ibrida</h3>
              <p className="text-[#5A6058] leading-relaxed mb-6 text-sm flex-1">
                Alternanza calibrata di incontri in presenza nei momenti chiave e sessioni online per il proseguimento dei lavori. Progettata per bilanciare l'operatività sul campo con la continuità da remoto.
              </p>
            </div>
          </div>
        </div>

        {/* SOCIAL */}
        <div className="mt-16 text-center">
          <p className="eyebrow mb-6">Trovami online</p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              data-testid="contatti-in"
              href="https://www.linkedin.com/in/roberta-castagna/"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-3 px-6 py-3 border border-[#323C36] text-[#323C36] text-xs uppercase tracking-[0.18em] font-semibold transition-all hover:bg-[#323C36] hover:text-[#F6F3EF]"
            >
              <Linkedin size={16} strokeWidth={1.7}/> LinkedIn
            </a>
            <a
              data-testid="contatti-ig"
              href="https://www.instagram.com/robertacastagna_/"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-3 px-6 py-3 border border-[#323C36] text-[#323C36] text-xs uppercase tracking-[0.18em] font-semibold transition-all hover:bg-[#323C36] hover:text-[#F6F3EF]"
            >
              <Instagram size={16} strokeWidth={1.7}/> Instagram
            </a>
            <a
              data-testid="contatti-gbp"
              href="https://share.google/kOfk1mZ4wFh9qx5TN"
              target="_blank"
              rel="noreferrer"
              aria-label="Roberta Castagna su Google"
              className="inline-flex items-center gap-3 px-6 py-3 border border-[#323C36] text-[#323C36] text-xs uppercase tracking-[0.18em] font-semibold transition-all hover:bg-[#323C36] hover:text-[#F6F3EF]"
            >
              <i className="fa-brands fa-google text-base" aria-hidden="true"/> Google
            </a>
          </div>

          <p className="mt-8 text-sm text-[#5A6058]">
            Hai già lavorato con me?{" "}
            <a
              data-testid="contatti-review"
              href="https://g.page/r/CbwGM0nU0qxTEBM/review"
              target="_blank"
              rel="noreferrer"
              className="text-[#A8674F] underline underline-offset-4 hover:text-[#323C36] font-semibold"
            >
              Lascia una recensione su Google →
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
